<template>
  <div class="content__column">
    <slot>
      <div class="content" v-html="html"></div>
    </slot>
  </div>
</template>

<script>
  export default {
    name: 'ncc-content-column',
    props: {
      html: {}
    }
  }
</script>

<style scoped>
  .content {
    padding: 1rem;
    color: #ffffff;
    background-color: #212529;
    font-size: 1.1rem;
    line-height: 2;
  }

  >>> .klein:first-child {
    margin-top: 1rem;
  }

  >>> .klein {
    opacity: .35;
    font-style: italic;
    font-size: .85rem;
  }

  @media all and (min-width: 769px) {
    .content {
      padding: 2.5rem;
    }
  }
</style>
